var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdvertising(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M15.191 3.045a.999.999 0 0 0-1.59.24L7.308 15.172l-3.43 3.43c-1.056 1.056-1.378 2.556-1.005 3.9-1.235 1.569-1.147 3.846.298 5.293A3.991 3.991 0 0 0 6 28.964c.875 0 1.74-.302 2.463-.871.351.097.71.164 1.072.164.701 0 1.398-.197 2.02-.563l2.577 2.575c.487.487 1.127.73 1.767.73s1.28-.243 1.768-.73a2.503 2.503 0 0 0 0-3.535l-2.475-2.475.601-.601 11.888-6.294a1 1 0 0 0 .24-1.59zM4.585 26.38a1.995 1.995 0 0 1-.51-1.925l2.435 2.436a1.995 1.995 0 0 1-1.925-.51zm3.536-.707-2.829-2.829a2.003 2.003 0 0 1 0-2.828l2.83-2.829 5.656 5.657-2.829 2.829c-.78.78-2.048.78-2.828 0zm8.132 2.475c.125.125.144.275.144.353s-.019.228-.144.353a.508.508 0 0 1-.707.001L13.07 26.38l.708-.707zm-.876-6.533-6.026-6.027 5.384-10.171L25.549 16.23zM19 4V2a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0zm11 7a1 1 0 0 1-1 1h-2a1 1 0 1 1 0-2h2a1 1 0 0 1 1 1zm-6.707-3.293a1 1 0 0 1 0-1.414l2-2a1 1 0 1 1 1.414 1.414l-2 2a.997.997 0 0 1-1.414 0z",
    fill: "#dbd4ce",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdvertising);
export default __webpack_public_path__ + "static/media/advertising.83492f408c35722ad486e102ed7bc205.svg";
export { ForwardRef as ReactComponent };